var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF780E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.827 7.30399C19.827 6.44312 19.1226 5.73877 18.2618 5.73877H5.74002C4.87915 5.73877 4.1748 6.44312 4.1748 7.30399V16.6953C4.1748 17.5562 4.87915 18.2605 5.74002 18.2605H18.2618C19.1226 18.2605 19.827 17.5562 19.827 16.6953V7.30399ZM18.2618 7.30399L12.0009 11.217L5.74002 7.30399H18.2618ZM18.2618 16.6953H5.74002V8.8692L12.0009 12.7822L18.2618 8.8692V16.6953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.cac4c523aa796d94b29ce69fe5a46836.svg";
export { ForwardRef as ReactComponent };